<style  lang="scss" scoped>
.subordinate-data {
    position: relative;
    display: flex;
    margin-left: 30px;
    .toggle{
        display: flex;
        justify-content: center;
        vertical-align: middle;
    }
    .el-icon-caret-bottom {
        margin-left: 10px;
    }
    .opacity-data {
        opacity: 0.5;
    }
    .subordinate-title {
        font-size: 16px;
        color: #409eff;
        margin-right: 10px;
    }
    .color-409eff {
        color: #409eff;
    }
    .color-646464 {
        color: #646464;
    }
    .fs-12 {
        font-size: 12px;
    }
    .subordinate {
        position: absolute;
        top: 0px;
        left: 0px;
        .el-popover {
            position: absolute;
            background: #fff;
            min-width: 270px;
            border-radius: 4px;
            border: 1px solid #ebeef5;
            padding: 0px;
            z-index: 2000;
            color: #606266;
            line-height: 1.4;
            text-align: justify;
            font-size: 14px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            word-break: break-all;
        }
        .similar-name {
            position: absolute;
            top: 30px;
            left: -89px;
            // right: -413px;
            border: solid 1px #dddfe5;
            // box-shadow: inset 0px -1px 0px 0px #ececec, inset 0px 1px 0px 0px #ececec;
            width: 270px;
            // height: 100px;
            z-index: 90;
            .similar-title {
                font-size: 14px;
                // line-height: 50px;
                letter-spacing: 1px;
                color: #c1c4cc;
            }
            .similar-list {
                max-height: 400px;
                overflow-y: scroll;
                .similar-row {
                    height: 48px;
                    font-size: 14px;
                    // line-height: 50px;
                    letter-spacing: 1px;
                    color: #323232;
                    cursor: pointer;
                    margin: 10px 20px 6px 20px;
                    border-top: 1px solid #ececec;
                    .similar-row-name {
                        margin-left: 32px;
                    }
                }
                .similar-diff {
                    text-align: center;
                    margin: 10px 20px 20px 20px;
                    color: #409eff;
                }
            }
            .x-popper__arrow {
                position: absolute;
                left: -18px;
            }
            .x-popper__arrow:after,
            .x-popper__arrow:before {
                top: -12px;
                left: 248px;
                width: 0;
                height: 0;
                border: 6px solid transparent;
                border-bottom-color: #dddfe5;
                position: absolute;
                content: "";
            }
            .x-popper__arrow:before {
                top: -10px;
                left: 248px;
                border-bottom-color: white;
                z-index: 999;
            }
        }
    }
}
</style>

<template>
    <div class="subordinate-data">
        <div  class="bm bm-ps">
            <div class="toggle" @click="showSubordinateFillStatus = !showSubordinateFillStatus">
                <div class="subordinate-title bm bm-ac">{{title}}<i class="el-icon-caret-bottom color-409eff"></i></div>
                
            </div>
            
            <div class="subordinate" v-if="showSubordinateFillStatus">
                <div class="similar-name bm bm-ver el-popover">
                    <div x-arrow="" class="x-popper__arrow"></div>
                    <div class="bm bm-ver similar-list">
                        <div
                            class="bm similar-row bm bm-ac bm-pc"
                            v-for="(data, index) of subordinateFillStatusList"
                            :key="index">
                            <div class="bm-f4" :class="{ 'opacity-data': data.completeFlag != 2 }">
                                <div>{{ data.fillPersonName }}</div>
                                <div class="color-646464 fs-12">
                                    {{ data.departName }}-{{ data.positionName}}
                                </div>
                            </div>
                            <div class="bm-f1" v-if="data.completeFlag == 2">
                                <div class="color-409eff" @click="turnTo(data)">查看</div>
                            </div>
                        </div>
                        <div class="similar-diff">
                            <div v-if="shouIncomingData" @click="subordinate" style="cursor:pointer;"> {{title}}</div>
                            <div v-else :class="{ 'opacity-data': !shouIncomingData }"> {{title}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "subordinate-data",
    watch: {
        subordinateFillStatusList(newValue, oldValue) {
            if(newValue){
                for (let data of newValue) {
                    if (data.completeFlag != "2") {
                        this.shouIncomingData = false;
                    }
                }
            }
            
        }
    },
    data() {
        return {
            showSubordinateFillStatus: false,
            shouIncomingData: true
        };
    },
    props: {
        subordinateFillStatusList: {
            type: Array
        },
        title:{
			type: String,
			default: function(){
				return "引入下级汇总数据"
			}
		}
    },
    created() {
        if(this.subordinateFillStatusList){
            for (let data of this.subordinateFillStatusList) {
                if (data.completeFlag != "2") {
                    this.shouIncomingData = false;
                }
            }
        }
         
    },
    mounted() {},
    methods: {
        turnTo(data){
            this.showSubordinateFillStatus = false;
            this.$emit("turnTo",data);
        },
        subordinate(){
            this.showSubordinateFillStatus = false;
            this.$emit("subordinate","test----");
        }
    }
};
</script>
<style scoped>
</style>